import { Platform } from 'react-native';
import { initializeApp, getApps, FirebaseApp } from 'firebase/app';
import { getFirestore, Firestore } from 'firebase/firestore';

// Konfiguracja Firebase dla web
// Wartości z google-services.json + authDomain
const firebaseConfig = {
  apiKey: "AIzaSyAp3qfI7ggXjqBWGXpGQkOrF6Y-Ls6ar4I",
  authDomain: "tino-ceaea.firebaseapp.com",
  projectId: "tino-ceaea",
  storageBucket: "tino-ceaea.firebasestorage.app",
  messagingSenderId: "404505757892",
  appId: "1:404505757892:web:d245f1f845f58d85302191",
  measurementId: "G-149D84FTD2"
};

let app: FirebaseApp | null = null;
let db: Firestore | null = null;

/**
 * Inicjalizuj Firebase dla web
 */
export const initializeFirebase = (): FirebaseApp | null => {
  if (Platform.OS !== 'web') {
    // Na natywnych platformach używamy @react-native-firebase
    return null;
  }

  if (app) {
    return app;
  }

  try {
    // Sprawdź czy app już jest zainicjalizowana
    if (getApps().length === 0) {
      app = initializeApp(firebaseConfig);
    } else {
      app = getApps()[0];
    }
    return app;
  } catch (error) {
    console.error('Firebase: Błąd inicjalizacji', error);
    return null;
  }
};

/**
 * Pobierz instancję Firestore
 */
export const getFirestoreInstance = (): Firestore | null => {
  if (Platform.OS !== 'web') {
    return null;
  }

  if (db) {
    return db;
  }

  const firebaseApp = initializeFirebase();
  if (!firebaseApp) {
    return null;
  }

  try {
    db = getFirestore(firebaseApp);
    return db;
  } catch (error) {
    console.error('Firestore: Błąd inicjalizacji', error);
    return null;
  }
};

export { firebaseConfig };
